import { createContext, SetStateAction, useEffect, useState } from 'react';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { CompanyFinepModel } from '../Models/CompanyFinepModel';
import { useAuth } from 'oidc-react';
import { useParams } from 'react-router-dom';
import { GetPercentageValidatedPersonaPJPF } from '../API/PercentageValidation';

interface ICompanyFinepProps {
    handleFillTab: (tab: number, isValidGroupsCount?: number) => void;
    handleUnfillTab: (tab: number, isValidGroupsCount?: number) => void;
    handleValidateTab: (tab: number, valisValidGroupsCountue?: number) => void;
    handleInvalidateTab: (tab: number, isValidGroupsCount?: number) => void;
    addCompany: (companyModel: CompanyFinepModel) => void;
    handleChangeTab: (event: React.SyntheticEvent, newValue: number) => void;
    changeTab: (newValue: number) => void;
    changeIsAnonymousSociety: (value: boolean) => void;
    update: () => void;
    validateModel: typeof tabsToValidate;
    company: CompanyFinepModel,
    value: number;
    validateValue: number;
    loading: boolean,
}

const tabsToValidate = [
    {
        tab: 0,
        totalFields: 1,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 1,
        totalFields: 1,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 2,
        totalFields: 2,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 3,
        totalFields: 2,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 4,
        totalFields: 1,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 5,
        totalFields: 1,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
]

export const CompanyFinepContext = createContext({} as ICompanyFinepProps);

export const CompanyContextFinepProvider = ({ children }: IChildrenProps) => {
    const [value, setValue] = useState(0);
    const [company, setCompany] = useState<CompanyFinepModel>({} as CompanyFinepModel);
    const [validateModel, setValidateModel] = useState<typeof tabsToValidate>(tabsToValidate);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => setValue(newValue);
    const changeTab = (newValue: number) => setValue(newValue);
    const addCompany = async (companyModel: CompanyFinepModel) => setCompany(companyModel);
    const changeIsAnonymousSociety = async (value: boolean) => {
        setCompany({
            ...company,
            isAnonymousSociety: value
        });
    }
    const [validateValue, setValidateValue] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const { registerId } = useParams();
    const auth = useAuth();
    let userData = auth?.userData;

    const handleValidateTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.totalFields >= x.validatedsCount + 1) {
                    x.validatedsCount = isValidGroupsCount ? x.validatedsCount + isValidGroupsCount : x.validatedsCount + 1;
                    x.validatedsPercentage = 100 * (x.validatedsCount) / totalFields;
                }
            return x;
        });
        setValidateModel(newModel);
    }

    const handleInvalidateTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.validatedsCount - 1 >= 0) {
                    x.validatedsCount = isValidGroupsCount ? x.validatedsCount - isValidGroupsCount : x.validatedsCount - 1;
                    x.validatedsPercentage = 100 * (x.validatedsCount) / totalFields;
                }
            return x;
        });
        setValidateModel(newModel);
    }

    const handleFillTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.totalFields >= x.filledsCount + 1) {
                    x.filledsCount = isValidGroupsCount != undefined ? x.filledsCount + isValidGroupsCount : x.filledsCount + 1;
                    x.filledsPercentage = 100 * (x.filledsCount) / totalFields;
                }
            return x;
        });
        setValidateModel(newModel);
    }

    const handleUnfillTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.filledsCount - 1 >= 0) {
                    x.filledsCount = isValidGroupsCount ? x.filledsCount - isValidGroupsCount : x.filledsCount - 1;
                    x.filledsPercentage = 100 * (x.filledsCount) / totalFields;
                }
            return x;
        });
        setValidateModel(newModel);
    }

    const update = () => {
        getValidates();
    }

    const getValidates = async () => {
        setLoading(true);

        await GetPercentageValidatedPersonaPJPF(registerId!, userData?.access_token!)
            .then(x => setValidateValue(x.data))
            .catch(x => setValidateValue(0));
        setLoading(false);
    }

    useEffect(() => {
        if (registerId) {
            getValidates();
        }
    }, [])

    return (
        <>
            <CompanyFinepContext.Provider
                value={{
                    addCompany,
                    handleChangeTab,
                    changeTab,
                    handleFillTab,
                    handleUnfillTab,
                    handleInvalidateTab,
                    handleValidateTab,
                    changeIsAnonymousSociety,
                    update,
                    validateModel,
                    company,
                    value,
                    validateValue,
                    loading
                }}
            >
                {children}
            </CompanyFinepContext.Provider>
        </>
    )
}

